import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IActivity, IActivityState } from "./activityModel";
import {
  activityActiveInactive,
  createActivity,
  deleteActivity,
  getAllActiveActivities,
  getAllActivities,
  getActivityByID,
  updateActivity,
} from "./service/activity.services";

const initialState: IActivityState = {
  loading: false,
  formLoading: false,
  error: "",
  ActivityList: [],
  ActivityID: null,
  ActivityDetail: {
    ActivityName: "",
    IsActive: 1,
  },
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearActivityDetails: (state) => {
      state.ActivityDetail = initialState.ActivityDetail;
    },
    setActivityID: (state, action) => {
      state.ActivityID = action.payload;
    },
    clearActivityID: (state) => {
      state.ActivityID = initialState.ActivityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActivities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivities.fulfilled,
      (state, action: PayloadAction<IActivity[]>) => {
        state.loading = false;
        state.ActivityList = action.payload || [];
      }
    );
    builder.addCase(getAllActivities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActivityList = [];
    });
    builder.addCase(getAllActiveActivities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveActivities.fulfilled,
      (state, action: PayloadAction<IActivity[]>) => {
        state.loading = false;
        state.ActivityList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveActivities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActivityList = [];
    });
    builder.addCase(createActivity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createActivity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createActivity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateActivity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateActivity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateActivity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteActivity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(activityActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activityActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activityActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getActivityByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getActivityByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ActivityDetail = action.payload;
    });
    builder.addCase(getActivityByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ActivityDetail = initialState.ActivityDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearActivityDetails, setActivityID, clearActivityID } =
  activitySlice.actions;
export default activitySlice.reducer;
